import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState } from "react";
import Banner from '@/components/PageBanner';
import ContactForm from '@/components/ContactForm';

export default function AboutUs({pageContent, siteSettings}:any) {
  return (
    <>
    <Head>
      <title>The Line of Sight &#8480;</title>
    </Head>
    <Nav />
    <main className="row about-content-row">
      <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
      <div className="col-12 about-content-col">
        <div className="container">
          <div className="row about-content-container-row">
            <div className="col-12 title-col title-font">
              <div dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].heading)}}>
                 
              </div>

              <p>{pageContent[0].sub_heading}</p>
            </div>
            <div className="col-12 col-sm-6 text-col regular-font" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].description)}}>

            </div>
            <div className="col-12 col-sm-6 img-col">
              <img src={urlFor(pageContent[0].graphic).width(1000).url()} />
            </div>
          </div>
        </div>
      </div>
      <ContactForm adminEmails={siteSettings[0].admin_emails} />
    </main>
    <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "aboutPage"]`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      siteSettings: siteSettings
    }
  }
}
